import withObservables from "@nozbe/with-observables";
import { useAuthContext } from "../../../../context/AuthContext";
import { memo, useCallback, useContext, useState } from "react";
import { useSnackbar } from "../../../../context/SnackbarContext";
import { useNavigate } from "react-router-dom";
import { Box, capitalize, CircularProgress, Tooltip } from "@mui/material";
import {
  BlackCheckIcon,
  DeleteNewIcon,
  DownloadIcon,
  EditIcon,
  ReminderOutlineIcon,
} from "../../../../assets/icons/icon";
import { ParagraphText, UBAppModal, UBButton } from "../../../../Libraries";
import { navigateToEdit } from "../invoiceBookUtils";
import { LanguageContext } from "../../../../context/LanguageContext";
import { PopoverMenu } from "../../../common";
import EditCustomer from "../../../common/EditCustomer";
import {
  bulkDeleteOrders,
  bulkRestoreStock,
} from "../../../../database/helpers/orders";
import { bulkDeleteInventory } from "../../../../database/helpers/inventory";
import {
  bulkCreatePayments,
  bulkDeletePaymentsV2,
  getPaymentsByInvoiceExternal,
} from "../../../../database/helpers/payment";
import { calculateTotalOutstanding } from "../../../../database/helpers/customer";
import { Sync } from "../../../../SyncService";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import { toast } from "react-toastify";
import { formatNum, uuid } from "../../../../oscar-pos-core/constants";
import { catchError, of } from "rxjs";
import { dateFormatInNumberWithSpace, getDueInfo, handleShareDetails } from "../../../../utils";
import useDownlaodPdf from "../../../../hooks/useDownlaodPdf";
import RecordPaymentModal from "../../../common/Modals/RecordPaymentModal";
import SidebarBodyContent from "../../../common/UBRightSidebar/SidebarBodyContent";
import ConfirmationModal from "../../../common/Modals/ConfirmationModal";
import AddContactSelector from "../../../common/AddContactSelector";
import { sentenceCase } from "../../../../constants";
import { useWalletContext } from "../../../../context/WalletContext";
import AttachContactMessage from "../../../common/AttachContactMessage";

const InvoiceRowItem = memo(
  ({
    customerDetail,
    invoiceDetail,
    invoice,
    customers,
    refetchInvoiceList,
    location,
    orders,
    type,
    index,
    isAccountLoading,
    accountInfo,
    fetchAccountInfo,
    companyDetail,
    selectedContactId,
    setSelectedContactId,
    justClosedDropdownRef,
  }) => {
    customerDetail = customerDetail?.length
      ? customerDetail[0]
      : customerDetail;

    const contactList = customers?.length ? customers : [];

    const { business, user } = useAuthContext();
    const [I18n] = useContext(LanguageContext);
    const navigate = useNavigate();
    const { showSnackbar } = useSnackbar();
    const {EMIVerified} = useWalletContext();
    const { id, customer, ...invoiceDisplayData } = invoiceDetail || {};
    invoiceDisplayData.cust_name = customerDetail?.name || I18n.add_contact;
    invoiceDisplayData.is_contact_added = customerDetail?.name ? true : false;
    const [showEditCustomer, setShowEditCustomer] = useState(false);
    const [showRecordPayment, setShowRecordPayment] = useState(false);
    const [isActionLoading, setIsActionLoading] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [openDetailSidebar, setOpenDetailSidebar] = useState(false);
    const [isOpenRecordPaymentModal, setIsOpenRecordPaymentModal] =
      useState(false);
    const [selectedId, setSelectedId] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedCustomer, setSelectedCustomer] = useState("");
    const [editCustomerFormState, setEditCustomerFormState] = useState({
      loading: false,
      disabled: true,
    });
    const editCustomerFormId = "invoice_row_edit_customer_form";

    const { onDownload, downloadLoading } = useDownlaodPdf(user);

    const addedCustomer = customerDetail;

    const handleRemindToast = (info, severity) => {
      showSnackbar({ message: info, severity });
      setIsActionLoading(false);
    };

    const handleDetail = () => {
      triggerLogEvent(analytics, type === "in" ? "inv_detail" : "pb_detail");
      setShowRecordPayment(false);
      setOpenDetailSidebar(true);
    };

    const handleSendReminder = async () => {
      setSelectedId(invoice.id);
      let info = accountInfo;
      if (!info && user?.phone_number) {
        info = await fetchAccountInfo(navigate);
      }
      handleShareDetails(business.name, info, invoice, navigate);
    };

    const handleEditCustomerFormStateChange = useCallback((nextState) => {
      setEditCustomerFormState(nextState);
    }, []);

    const handleEdit = (e, source) => {
      e.stopPropagation();
      if (source === "option") {
        triggerLogEvent(
          analytics,
          type === "in" ? "inv_options_edit" : "pb_options_edit",
        );
      } else {
        triggerLogEvent(
          analytics,
          type === "in" ? "inv_edit_btn" : "pb_edit_btn",
        );
      }
      navigateToEdit(
        navigate,
        invoice.type,
        {
          invoiceId: invoice.id,
          customerId: invoice?.customer?.id || "",
        },
        location,
      );
    };

    const handleDownload = async (e, source) => {
      e.stopPropagation();

      let paramsForReport = {
        template_name: "invoicereport.hbs",
        name: type === "in" ? "Rupin Sale Invoice.pdf" : "Rupin Purchase Order.pdf",
        invoice_id: invoice.id,
        template_style: localStorage.getItem("invoiceStyle") || "style1",
        template_color: localStorage.getItem("invoiceColor") || "#000000",
        pdf: true,
      };

      const pdfType = "Invoice";
      const onSuccessDownload = () => {
        if (source === "header") {
          triggerLogEvent(
            analytics,
            type === "in" ? "inv_download" : "pb_download",
          );
        } else {
          triggerLogEvent(
            analytics,
            type === "in" ? "inv_options_download" : "pb_options_download",
          );
        }
      };
      onDownload(
        paramsForReport,
        onSuccessDownload,
        navigate,
        pdfType,
        business,
      );
    };

    const InvoiceActions = [
      {
        label: (
          <Box display={"flex"} alignItems={"center"}>
            <Box marginRight={2}>
              <EditIcon width={20} height={20} />
            </Box>
            <ParagraphText className="textCapitalizeFirstLetter">
              {I18n.edit}
            </ParagraphText>
          </Box>
        ),
        hideOnPaid: true,
        action: (e) => {
          handleEdit(e, "option");
        },
      },

      {
        label: (
          <Box display={"flex"} alignItems={"center"}>
            <Box marginRight={2} display={"flex"}>
              <DownloadIcon width={20} height={18} id="download_black_btn" />
            </Box>
            <ParagraphText
              className={type == "in" && "textCapitalizeFirstLetter"}
            >
              {type == "in" ? I18n.download_invoice : I18n.download_po}
            </ParagraphText>
          </Box>
        ),
        action: (e) => {
          handleDownload(e, "option");
        },
      },

      ...(type == "in" && EMIVerified
        ? [
            {
              label: (
                <Box display={"flex"} alignItems={"center"}>
                  <Box marginRight={2} display={"flex"}>
                    <ReminderOutlineIcon width={16} height={16} />
                  </Box>
                  <ParagraphText className="textCapitalizeFirstLetter">
                    {I18n.send_reminder}
                  </ParagraphText>
                </Box>
              ),
              hideOnPaid: true,
              action: (e) => {
                e.stopPropagation();
                triggerLogEvent(
                  analytics,
                  type === "in"
                    ? "inv_options_reminder"
                    : "pb_options_send_money",
                );
                handleSendReminder();
              },
            },
          ]
        : []),
      {
        label: (
          <Box display={"flex"} alignItems={"center"}>
            <Box marginRight={2}>
              <BlackCheckIcon width={16} height={16} />
            </Box>
            <ParagraphText className="textCapitalizeFirstLetter">
              {" "}
              {I18n.record_payment}
            </ParagraphText>
          </Box>
        ),
        action: (e) => {
          triggerLogEvent(
            analytics,
            type === "in"
              ? "inv_options_record_payment"
              : "pb_options_record_payment",
          );
          e.stopPropagation();
          document.activeElement?.blur();
          setIsOpenRecordPaymentModal(true);
        },
        hideOnPaid: true,
      },

      {
        label: (
          <Box display={"flex"} alignItems={"center"}>
            <Box marginRight={2} display={"flex"}>
              <DeleteNewIcon width={20} height={18} id="download_black_btn" />
            </Box>
            <ParagraphText className="textCapitalizeFirstLetter">
              {I18n.delete}
            </ParagraphText>
          </Box>
        ),
        action: (e) => {
          e.stopPropagation();
          triggerLogEvent(
            analytics,
            type === "in" ? "inv_options_delete" : "pb_options_delete",
          );
          setShowDeleteModal(true);
        },
      },
    ];

    const handleDelete = async () => {
      setShowDeleteModal(false);
      setIsActionLoading(true);

      if (orders.length) {
        let toDelete = [];
        await Promise.all(
          orders.map(async (item) => {
            let stock = await item.stock.fetch();

            toDelete.push({
              original: item,
              updated: stock,
            });
          }),
        );

        if (toDelete.length) {
          await bulkRestoreStock(toDelete, invoice.type);
          await bulkDeleteOrders(toDelete);
          await bulkDeleteInventory(invoice, toDelete, invoice.type, "invoice");
        }
      }
      if (customerDetail) {
        let payments = await invoice.payment.fetch();
        await bulkDeletePaymentsV2(payments);

        let total = await calculateTotalOutstanding(customerDetail);
        await customerDetail.updateTotalOutstanding(total);
      }

      await invoice.markAsDeleted();
      refetchInvoiceList();
      setIsActionLoading(false);
      Sync(user.phone_number, navigate);
      triggerLogEvent(analytics, type === "in" ? "inv_deleted" : "pb_deleted");
      showSnackbar({
        message: I18n.transaction_deleted,
        severity: "success",
        icon: "",
      });
    };

    const handleInvoicePaymentMethod = async (data, createdInvoice) => {
      let { method, bank, wallet, advance_amount } = data;

      let params = {
        method: method || "cash",
        bank,
        wallet,
        amount: advance_amount,
      };
      try {
        let invPayments = await createdInvoice?.invoice_payments.fetch();
        if (!invPayments?.length) {
          await createdInvoice.createTransactionPayments(params);
        } else {
          await invPayments[0].updateInvPayment(params);
        }
      } catch (error) {
      }
    };

    const updateInvoiceData = async (data) => {
      invoice.updateInvocie(data).then(async () => {
        await Sync(user?.phone_number, navigate);
      });
    };

    const handleEditInvoice = async (
      amountRecvd,
      paymentMethod,
      selected_date,
      customer,
    ) => {
      const invoiceCount = business.invoice_number_count;
      const invoiceAmountObj = {
        discount: invoice?.discount || 0,
        discount_unit: invoice?.discount_unit || "rs",
        tax_rate: invoice?.tax_rate || 0,
        total: 0,
        sub_total: invoice?.sub_total || 0,
        advance_amount: invoice?.advance_amount || 0,
        profit: invoice?.profit || 0,
      };
      let invoiceAmount = Number(invoice?.amount) || 0;
      let invoiceStatus =
        invoiceAmount - (Number(amountRecvd) || 0) === 0 ? "paid" : "unpaid";
      let partialAmount = invoiceAmount - (Number(amountRecvd) || 0);
      const inv_items = await invoice.orders.fetch();
      const currentMethod = !paymentMethod ? invoice?.method : paymentMethod;

      let invoiceData = {
        sales_amount: type == "in" ? invoiceAmount : 0,
        cost_amount: type == "out" ? invoiceAmount : 0,
        amount: invoiceAmount,
        date: selected_date
          ? selected_date
          : invoice.transacted_at || new Date(),
        customer: customer,
        items: inv_items || [],
        image_url: invoice?.image_url || "",
        document_url: invoice?.document_url || "",
        signature: invoice?.signature,
        attachment: invoice?.attachment || [],
        note: invoice?.note,
        status: invoiceStatus,
        method: currentMethod,
        type: invoice?.type,
        tranType: "bill",
        bank:
          currentMethod === "bank"
            ? paymentMethod?.name
            : invoice?.bank || null,
        wallet:
          currentMethod === "wallet"
            ? paymentMethod?.name
            : invoice?.bank || null,
        invoice_title: invoice?.invoice_title,
        invoice_number_count: invoiceCount + 1,
        invoice_number:
          invoice?.invoice_number || business.invoice_number_count,
        invoice_prefix:
          invoice?.invoice_prefix || business.invoice_number_prefix,
        discount: Number(invoiceAmountObj?.discount) || 0,
        discount_unit: invoiceAmountObj?.discount_unit,
        tax_rate: Number(invoiceAmountObj?.tax_rate) || 0,
        total: Number(invoiceAmountObj?.total) || 0,
        sub_total: Number(invoiceAmountObj?.sub_total) || 0,
        advance_amount: Number(amountRecvd) || 0,
        profit: Number(invoiceAmountObj?.profit) || 0,
        partialAmount,
      };
      if (customer && !addedCustomer) {
        await handleCreateCustomerPayment(customer, invoiceData, invoice);
      } else if (customer) {
        let dataForPayment = {
          udhaar_note: invoiceData?.note,
          date: invoiceData?.date || new Date(),
          image_url: invoiceData?.image_url || null,
          invoice,
          type: "invoicebook",
        };

        if (invoiceAmount != invoice?.amount) {
          dataForPayment["amount"] = invoiceAmount;
          let invoicePayment = await getPaymentsByInvoiceExternal(
            invoice?.id,
            "full_invoice",
          );

          if (invoicePayment.length) {
            await invoicePayment[0].updatePayment(dataForPayment);
          } else {
            await customer.createPayment({
              ...dataForPayment,
              uid: uuid(),
              date: new Date(),
              payment_mode: type == "in" ? "Udhaar" : "Jama",
              external_type: "full_invoice",
            });
          }
        } else if (Number(invoice?.advance_amount) != Number(amountRecvd)) {
          dataForPayment["amount"] = Number(amountRecvd);

          let invoicePayment = await getPaymentsByInvoiceExternal(
            invoice?.id,
            "partial_invoice",
          );

          if (invoicePayment.length) {
            await invoicePayment[0].updatePayment(dataForPayment);
          } else {
            await customer.createPayment({
              ...dataForPayment,
              uid: uuid(),
              date: new Date(),
              payment_mode: type == "in" ? "Jama" : "Udhaar",
              external_type: "partial_invoice",
            });
          }
        } else if (invoiceStatus == "paid") {
          dataForPayment["amount"] = Number(amountRecvd);

          let invoicePayment = await getPaymentsByInvoiceExternal(
            invoice?.id,
            "partial_invoice",
          );

          if (invoicePayment.length) {
            await invoicePayment[0]?.updatePayment(dataForPayment);
          } else {
            await customer.createPayment({
              ...dataForPayment,
              uid: uuid(),
              date: new Date(),
              payment_mode: type == "in" ? "Jama" : "Udhaar",
              external_type: "partial_invoice",
            });
          }
        }

        let totalOutstanding = await calculateTotalOutstanding(customer);

        await customer.updateTotalOutstanding(totalOutstanding);
      }

      await handleInvoicePaymentMethod(invoiceData, invoice);

      updateInvoiceData(invoiceData)
        .then((ans) => {
          refetchInvoiceList();
          triggerLogEvent(
            analytics,
            type === "in" ? "inv_record_name" : "pb_record_name",
          );
          triggerLogEvent(
            analytics,
            type === "in" ? "inv_record_method" : "pb_record_method",
          );
          triggerLogEvent(
            analytics,
            type === "in" ? "inv_record_amount" : "pb_record_amount",
          );
          triggerLogEvent(
            analytics,
            type === "in" ? "inv_record" : "pb_record",
          );
          setOpenDetailSidebar(false);
          setIsOpenRecordPaymentModal(false);
          showSnackbar({
            message: I18n.update_record_sucessfully,
            severity: "success",
          });
        })
        .catch((er) => {
        });
    };

    const handleCreateCustomerPayment = async (customer, data, invoice) => {
      let payObj = {
        date: data?.date || new Date(),
        udhaar_note: data?.note || "",
        imageURL: data?.image_url || "",
        type: "invoicebook",
      };

      let paymentArr = [
        {
          ...payObj,
          uid: uuid(),
          amount: data.amount,
          payment_mode: type == "in" ? "Udhaar" : "Jama",
          external_type: "full_invoice",
        },
      ];

      if (data?.advance_amount > 0) {
        paymentArr.unshift({
          ...payObj,
          uid: uuid(),
          amount: Number(data.advance_amount),
          payment_mode: type == "in" ? "Jama" : "Udhaar",
          external_type: "partial_invoice",
        });
      }

      await bulkCreatePayments(business, customer, invoice, paymentArr);

      let totalOutstanding = await calculateTotalOutstanding(customer);

      await customer.updateTotalOutstanding(totalOutstanding);
    };

    const handleRecordPayment = (
      selectedMethod,
      selectedDate,
      receivedAmount,
    ) => {
      handleEditInvoice(
        Number(receivedAmount) + Number(invoice.advance_amount),
        selectedMethod,
        selectedDate,
        customerDetail,
      );
    };

    const handleSelectCustomer = async (customer) => {
      setSelectedCustomer(customer);
      setSelectedContactId(null);
    };

    const handleAddCustomer = async (customer) => {
      try {
        await invoice.updateInvoiceCustomer(customer);

        if (invoice?.status?.toLowerCase() != "paid") {
          const data = {
            amount: invoice.amount,
            date: invoice.transacted_at,
            image_url: invoice.image_url,
            note: invoice.note,
            advance_amount: invoice.advance_amount,
          };

          await handleCreateCustomerPayment(customer, data, invoice);
        }
        setSearchQuery("");
        Sync(user.phone_number, navigate);
        showSnackbar({
        message: I18n.contact_attached_successfully,
        severity: "success",
      });
        setSelectedCustomer("");
      } catch (error) {
        await invoice.updateInvoiceCustomer(null);
      }
    };

    const customerInfoData = [
      {
        title: I18n.contact,
        value: customerDetail?.name || companyDetail?.name || "-",
      },
      {
        title: `${type == "in" ? I18n.invoice_no : I18n.PO_no}.  `,
        value: invoiceDetail?.inv_num?.replace("#", " #"),
      },
      {
        title: type == "in" ? I18n.invoice_date : I18n.po_date,
        value: invoice?.created_at
          ? dateFormatInNumberWithSpace(invoice?.created_at)
          : "-",
      },
      {
        title: I18n.due_date,
        value: invoice?.due_date && invoice?.due_date > 0
          ? dateFormatInNumberWithSpace(invoice?.due_date)
          : "-",
      },
      {
        title: I18n.amount_received,
        value: `Rs. ${formatNum(invoice?.advance_amount)}` || "Rs. 0",
      },
      {
        title: I18n.balance,
        value:
          `Rs. ${formatNum(Number(invoice?.amount) - Number(invoice.advance_amount))}` ||
          "Rs. 0",
      },
    ];

    const dueInfo = getDueInfo(
      invoice?.due_date && invoice?.due_date > 0 ? invoice?.due_date : "",
      I18n.overdue,
    );

    return (
      <Box
        id={`${type === "in" ? `list_inv_${index}` : `list_pb_${index}`}`}
        className="invoiceListTableBody AccountItemListWrapper user-select-none"
        onClick={(e) => {
          if (
            showDeleteModal ||
            selectedCustomer ||
            openDetailSidebar ||
            isOpenRecordPaymentModal ||
            justClosedDropdownRef.current
          )
            return;
          e.stopPropagation();
          if (selectedContactId) {
            setSelectedContactId("");
            return;
          }
          handleDetail();
        }}
      >
        <Box className="invListTableHeaderCol eightColumn textLeft sidebarOption">
          <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textLeft newFontColor">
            {invoiceDisplayData.date}
          </ParagraphText>
        </Box>

        <Box className="invListTableHeaderCol eightColumn textLeft">
          <AddContactSelector
            selectedContact={
              customerDetail?.name
                ? {
                    id: customerDetail?.id,
                    name: customerDetail.name,
                  }
                : null
            }
            contacts={contactList || []}
            isOpen={selectedContactId === invoice?.id}
            onOpenChange={(open) => {
              if (!customerDetail && !selectedContactId) {
                setSelectedContactId(open ? invoice.id : "");
              } else if (selectedContactId) {
                justClosedDropdownRef.current = true;
                setSelectedContactId("");
                setTimeout(() => {
                  justClosedDropdownRef.current = false;
                }, 100);
              } else if (
                !selectedContactId &&
                !justClosedDropdownRef?.current
              ) {
                setOpenDetailSidebar(true);
              }
            }}
            onSelect={handleSelectCustomer}
            addContactLabel={I18n.add_contact || "Add contact"}
            searchPlaceholder={I18n.search_contact || "Search contact"}
          />
        </Box>

        <Box className="invListTableHeaderCol eightColumn textLeft">
          <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textLeft newFontColor">
            <span className="truncate invoiceNumbercol">
              {type == "in" ? sentenceCase(invoiceDisplayData.inv_num?.replace("#", " #")) : invoiceDisplayData.inv_num?.replace("#", " #")}
            </span>
          </ParagraphText>
        </Box>

        <Box className="invListTableHeaderCol eightColumn textLeft">
          <ParagraphText
            className={`fontSize14 fontWeight400 truncateOneLine textLeft newFontColor ${
              dueInfo.isPast ? "redColor" : "newFontColor"
            }`}
          >
            {dueInfo.text}
          </ParagraphText>
        </Box>

        <Box className="invListTableHeaderCol eightColumn textLeft">
          <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textLeft newFontColor displayFlex">
            {invoiceDisplayData.status ? (
              // Status/method arrive in English; show the translated label when a key exists
              <span>{capitalize(I18n[invoiceDisplayData.status?.toString?.().toLowerCase()] || invoiceDisplayData.status?.toString?.())} {invoiceDisplayData.method && ` / ${sentenceCase(I18n[String(invoiceDisplayData.method).toLowerCase()] || invoiceDisplayData.method)}`} </span>
            ) : (
              <span>-</span>
            )}
          </ParagraphText>
        </Box>

        <Box className="invListTableHeaderCol eightColumn textRight">
          <ParagraphText
            className={`fontSize14 fontWeight400 truncateOneLine textRight ${invoiceDisplayData.status?.toString?.().toLowerCase() === "paid" ? "newFontColor" : "foundationOrangeColor"}`}
          >
            <span className="marginRight2">Rs.</span>
            <span>{invoiceDisplayData.amount}</span>
          </ParagraphText>
        </Box>

        <Box className="invListTableHeaderCol eightColumn textRight">
          <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textRight newFontColor">
            <span className="marginRight2">Rs.</span>
            <span>{invoiceDisplayData.balance}</span>
          </ParagraphText>
        </Box>

        <Box className="amountColumnInnerWrapper invListTableHeaderCol eightColumn textCenter">
          <ParagraphText className="fontSize14 fontWeight400 textCenter newFontColor tableActionsCell">
            <div className="tblOptnBox" role="button">
              <Tooltip
                title={I18n.share}
                arrow
                slotProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: "#24272F",
                      padding: "0.5rem 0.75rem",
                      color: "#fff",
                      fontFamily: "outfit",
                    },
                  },
                  arrow: {
                    sx: {
                      color: "#24272F",
                      fontSize: "1rem",
                    },
                  },
                }}
              >
                <PopoverMenu
                  id={"inv_menu"}
                  menuOptions={InvoiceActions.filter(
                    (acts) =>
                      !(
                        acts?.hideOnPaid &&
                        invoice?.status?.toLowerCase() === "paid"
                      ),
                  )}
                  popOverStyle={{
                    marginLeft: "5px",
                    borderRadius: "16px !important",
                  }}
                  buttonStyle={{
                    backgroundColor: "var(--foundationGrey)",
                    width: "32px",
                    height: "36px",
                    borderRadius: "50%",
                  }}
                  popoverButton={
                    (downloadLoading ||
                      (isAccountLoading && selectedId == invoice?.id) ||
                      isActionLoading) && <CircularProgress size={"15px"} />
                  }
                  disabled={
                    downloadLoading ||
                    (isAccountLoading && selectedId == invoice?.id) ||
                    isActionLoading
                  }
                />
              </Tooltip>
            </div>
          </ParagraphText>
        </Box>

        <UBAppModal
          id="invoice_row_record_payment_modal"
          open={showEditCustomer}
          handleClose={() => {
            setShowEditCustomer(false);
          }}
          className={"customer-selector-create-modal"}
          header={{
            title: (
              <ParagraphText className="d-flex align-items-center">{`${I18n.edit_customer}`}</ParagraphText>
            ),
            handleClose: () => {
              setShowEditCustomer(false);
            },
          }}
          footer={[
            {
              data: {
                className:
                  "foundationInk800 fontSize14 fontWeight400 textUppercase cursorPointer",
                title: I18n.cancel,
                onClick: () => setShowEditCustomer(false),
                id: "edit_customer_cancel",
              },
            },
            {
              data: {
                className: "ubPrimaryButton",
                title: I18n.save,
                type: "submit",
                form: editCustomerFormId,
                loading: editCustomerFormState.loading,
                disabled: editCustomerFormState.disabled,
                id: "edit_customer_save",
              },
            },
          ]}
        >
          <EditCustomer
            customer={customerDetail}
            closeCallback={() => {
              setShowEditCustomer(false);
            }}
            handleRemindToast={handleRemindToast}
            isTypeField={false}
            handleLogEventCustomerCreated={() =>
              triggerLogEvent(
                analytics,
                type === "in" ? ` inv_customer_created` : `pb_supplier_created`,
                {},
              )
            }
            handleLogEventCustomerUpdate={() =>
              triggerLogEvent(analytics, "customer_data_updated")
            }
            formId={editCustomerFormId}
            onFormStateChange={handleEditCustomerFormStateChange}
          />
        </UBAppModal>

        {openDetailSidebar ? <SidebarBodyContent
          open={openDetailSidebar}
          onClose={() => setOpenDetailSidebar(false)}
          quickSale={invoice}
          orders={orders}
          handleDelete={() => setShowDeleteModal(true)}
          handleEdit={handleEdit}
          customerDetail={customerDetail}
          companyDetail={companyDetail}
          handleMarkAsPaid={() => setIsOpenRecordPaymentModal(true)}
          firstButtonTitle={I18n.record_payment}
          customerInfoData={customerInfoData}
          isNotShowReceipt={true}
          isShowAttachment={false}
          invoiceBtnTitle={type == "in" ? I18n.invoice : I18n.download_po}
          invoiceFileName={type == "in" ? "Rupin Sale Invoice" : "Rupin Purchase Order"}
          otherCstmBtn={
            type == "in" && EMIVerified &&
            invoice?.status?.toLowerCase() != "paid" &&  [
              <UBButton
                id={"invoice_send_reminder_btn"}
                iconComponent={
                  <ReminderOutlineIcon id="send_reminder_btn_icon" />
                }
                loading={isAccountLoading && selectedId == invoice.id}
                title={I18n.send_reminder}
                onClick={() => handleSendReminder()}
              />,
            ]
          }
        /> : null}

        {showDeleteModal && (
          <ConfirmationModal
            open={showDeleteModal}
            onClose={() => setShowDeleteModal(false)}
            onConfirm={handleDelete}
            title={I18n.this_action_cannot_be_undone}
            message={
              type == "in"
                ? I18n.are_you_sure_you_want_to_delete_invoice
                : I18n.are_you_sure_you_want_to_delete_transaction
            }
            confirmText={I18n.delete}
            id="inv_delete"
          />
        )}

        {selectedCustomer && (
          <ConfirmationModal
            open={Boolean(selectedCustomer)}
            onClose={() => setSelectedCustomer("")}
            confirmButtonClassName="ubPrimaryButton"
            onConfirm={() => handleAddCustomer(selectedCustomer)}
            title={I18n.you_wont_be_able_to_change_it_later}
            htmlMessage={
              <AttachContactMessage name={selectedCustomer.name} />
            }
            confirmText={I18n.confirm}
            id="quick_sale_add_contact_cofirm_modal"
          />
        )}

        {isOpenRecordPaymentModal ? (
          <Box onClick={(e) => e.stopPropagation()}>
            <RecordPaymentModal
              handleConfirm={handleRecordPayment}
              handleClose={() => setIsOpenRecordPaymentModal(false)}
              isOpen={isOpenRecordPaymentModal}
              title={I18n.record_payment}
              selectedInvoice={invoice}
            />
          </Box>
        ) : null}
      </Box>
    );
  },
);

const enhance = withObservables(
  ["invoice", "business"],
  ({ invoice, business }) => ({
    customerDetail: invoice?.customer
      ?.observe()
      .pipe(catchError((error) => of({}))),
    orders: invoice.orders.observe(),
    companyDetail: invoice.company
      .observe()
      .pipe(catchError((error) => of(null))),
    invoice,
  }),
);

export default enhance(InvoiceRowItem);
